import { createContext } from 'react'
import { AdGroupEditFormContextType } from 'pages/AdGroupEdit/components/types'

const temporaryInitialValue: AdGroupEditFormContextType = {
  getAdGroupEditState: () => undefined,
  setAdGroupEditState: () => undefined,
}

export const AdGroupEditFormContext = createContext(temporaryInitialValue)
